exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-jumbotron__image[data-v-1fbbfb0e]{min-width:0!important}.textDiv[data-v-1fbbfb0e]{background:transparent!important;border:1px solid currentcolor;font-size:25px;border-radius:28px;padding-right:13px;display:inline-flex;align-items:center;letter-spacing:-.02em!important;cursor:pointer}.textDiv[data-v-1fbbfb0e]:hover{background-color:#7a97c5!important;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fbbfb0e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modules/project_info.vue
// module id = 1599
// module chunks = 3